import type { EntityWithName } from 'src/lib/collection';

export const PROJECT_FOLDER_ACTIONS = {
  click: 'click',
  delete: 'delete',
  rename: 'rename',
  toggleSidebarPresence: 'toggleSidebarPresence',
} as const;

export type ProjectFolderAction =
  (typeof PROJECT_FOLDER_ACTIONS)[keyof typeof PROJECT_FOLDER_ACTIONS];

export interface ProjectFolder extends EntityWithName {
  onSidebar: boolean;
}
